unit GA.Return.Types;

interface



uses System.Generics.Collections  {$IFDEF PAS2JS},JS{$ENDIF};


//{$IFDEF PAS2JS}

//uses
//  JS, System.Generics.Collections;
//{$ENDIF}

type

  TTenantIdAndName = class
  public
    Id: Integer;
    TenantId: string;
    Name: string;
  end;

  TGiftAigOrgConfig = class
    Id: Integer;
    TenantId: string;
    /// <summary>
    ///   Only used when a Charity client is managed my an Agent
    /// </summary>
    AgentId: Integer;
    OrganisationKind: String;
    Depth: Integer;
    RefId: string;
    Name: string;
    Status: string;
    LicenseType: string;
    LicenseExpires: TDate;
    AuthUserCount: Integer;
  end;

  TGiftAidOrgData = class(TGiftAigOrgConfig)
    LegalName: string;
    Add1: string;
    Add2: string;
    Add3: string;
    Add4: string;
    Add5: string;
    PostCode: string;
    Country: string;
  end;

  TGAUser = class
    InternalId: Integer;
    // Sphinx App Values - read from JWT?
    OrganisationId: Integer;
//    OrganisationName: string;
    TenantId: string;
    JobTitle: string;
    JobPosition: string;
    Title: string;
    GivenName: string;
    LastName: string;
    Email: string;
    EmailConfirmed: Boolean;
    PhoneNumber: string;

    UserStatus: string; // TUserStatus;
    UserScope: string; // TUserScope;

    function Initials: string;
    function IsAdmin: Boolean;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject); virtual;
{$ENDIF}
  end;

  TGiftAidUser = class(TGAUser)
    // Local App Values
    HMRCPhone: string;
    HMRCPostCode: string;
    HMRCRegistered: Boolean;
    CanSubmit: Boolean;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject); override;
{$ENDIF}

  end;

  TUserCounts = class
    Licensed: Integer;
    Active: Integer;
    Inactive: Integer;
    Archived: Integer;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
    function AvailableSeats: Integer;
  end;

  TAgentCharity = class
    OrganisationId: Integer;
    OrganisationName: string;
    TenantId: string;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TOrganisationConfiguration = class
    ClearDownSubmission: boolean;
    NoMatching: boolean;
    SaveHMRCPassword: boolean;
    /// <summary>True once the HMRC config prompt has been shown for this tenant (first-login prompt). Stored in DB.</summary>
    HMRCPromptShown: boolean;

{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TPrepareClaimData = class
    Complete: boolean;
    ClaimId: integer;
    DonationCount: integer;
    Amount: currency;
    GiftAid: currency;
    GASDS: currency;
    AggregatedDonations: currency;
    OtherIncome: currency;
    GASDSAdjustments: currency;
    Adjustments: currency;
    CommunityBuildings: currency;

{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TClaimParameters = class
    Complete: boolean;
    OldestDate: string;
    NewestDate: string;
    ImportIds: string;
    ImportFiles: string;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TRetrievePreparedClaim = class
    Exists: boolean;
    PrepareJobId: integer;
    ClaimId: integer;
    OldestDate: string;
    NewestDate: string;
    ImportId: string;
    ClaimRef: string;
    DonationCount: integer;
    Amount: currency;
    GiftAid: currency;
    GASDS: currency;
    AggregatedDonations: currency;
    OtherIncome: currency;
    GASDSAdjustments: currency;
    Adjustments: currency;
    CommunityBuildings: currency;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

const
  /// <summary>Config version that introduced HMRCPromptShown. Clients pass this when calling GetOrganisationConfiguration so the server returns the key; older/rolled-back clients omit it and get config without the key.</summary>
  ORGANISATION_CONFIG_VERSION_WITH_HMRC_PROMPT_SHOWN = 2;


implementation

uses
  System.SysUtils,
  SMX.Auth.Shared;

{ TGiftAidUser }

{$IFDEF PAS2JS}

procedure TGAUser.Assign(Source: JS.TJSObject);
begin
  InternalId := Integer(Source.Properties['InternalId']);
  OrganisationId := Integer(Source.Properties['OrganisationId']);
//  OrganisationName := string(Source.Properties['OrganisationName']);
  TenantId := string(Source.Properties['TenantId']);
  JobTitle := string(Source.Properties['JobTitle']);
  JobPosition := string(Source.Properties['JobPosition']);
  Title := string(Source.Properties['Title']);
  GivenName := string(Source.Properties['GivenName']);
  LastName := string(Source.Properties['LastName']);
  Email := string(Source.Properties['Email']);
  EmailConfirmed := Boolean(Source.Properties['EmailConfirmed']);
  UserStatus := string(Source.Properties['UserStatus']);
  UserScope := string(Source.Properties['UserScope']);
  PhoneNumber := string(Source.Properties['PhoneNumber']);
end;
{$ENDIF}

function TGAUser.Initials: string;
begin
  result := '';
  if not GivenName.IsEmpty then
    result := GivenName.Substring(0, 1).ToUpper;
  if not LastName.IsEmpty then
    result := result + LastName.Substring(0, 1).ToUpper;
  result := result.TrimRight;
end;

function TGAUser.IsAdmin: Boolean;
begin
  result := (UserScope = SCOPE_ADMIN) or (UserScope = SCOPE_SUPERUSER);
end;

{$IFDEF PAS2JS}

procedure TGiftAidUser.Assign(Source: JS.TJSObject);
begin
  inherited;
  HMRCPhone := string(Source.Properties['HMRCPhone']);
  HMRCPostCode := string(Source.Properties['HMRCPostCode']);
  HMRCRegistered := Boolean(Source.Properties['HMRCRegistered']);
  CanSubmit := Boolean(Source.Properties['CanSubmit']);
end;
{$ENDIF}


{ TUserCounts }

function TUserCounts.AvailableSeats: Integer;
begin
  result := Licensed - Active;
end;


{$IFDEF PAS2JS}

procedure TUserCounts.Assign(Source: JS.TJSObject);
begin
  Licensed := Integer(Source['Licensed']);
  Active := Integer(Source['Active']);
  Inactive := Integer(Source['Inactive']);
  Archived := Integer(Source['Archived']);
end;

procedure TAgentCharity.Assign(Source: JS.TJSObject);
begin
  OrganisationId := Integer(Source['OrganisationId']);
  OrganisationName := string(Source['OrganisationName']);
  TenantId := string(Source['TenantId']);
end;


procedure TOrganisationConfiguration.Assign(Source: JS.TJSObject);
var
  lValue: JSValue;
  lStrValue: string;
begin
  ClearDownSubmission := boolean(Source['ClearDownSubmission']);
  NoMatching := boolean(Source['NoMatching']);
  SaveHMRCPassword := boolean(Source['SaveHMRCPassword']);
  if TJSObject(Source).HasOwnProperty('HMRCPromptShown') then
  begin
    lValue := Source['HMRCPromptShown'];
    // Handle both boolean and string values robustly
    // In Pas2JS, JSON booleans come through as actual booleans, but handle strings too
    if JS.isBoolean(lValue) then
      HMRCPromptShown := JS.toBoolean(lValue)
    else
    begin
      // If it's a string, check for "true" (case-insensitive)
      lStrValue := string(lValue);
      HMRCPromptShown := (lStrValue.ToLower = 'true');
    end;
  end
  else
    HMRCPromptShown := False;
end;


procedure TPrepareClaimData.Assign(Source: JS.TJSObject);
begin
  Complete := boolean(Source['Complete']);
  ClaimId := integer(Source['ClaimId']);
  DonationCount := integer(Source['DonationCount']);
  Amount := currency(Source['Amount']);
  GiftAid := currency(Source['GiftAid']);
  GASDS := currency(Source['GASDS']);
  AggregatedDonations := currency(Source['AggregatedDonations']);
  OtherIncome := currency(Source['OtherIncome']);
  GASDSAdjustments := currency(Source['GASDSAdjustments']);
  Adjustments := currency(Source['Adjustments']);
  CommunityBuildings := currency(Source['CommunityBuildings']);
end;

procedure TClaimParameters.Assign(Source: JS.TJSObject);
begin
  OldestDate := string(Source['OldestDate']);
  NewestDate := string(Source['NewestDate']);
  ImportIds := string(Source['ImportIds']);
  ImportFiles := string(Source['ImportFiles']);
end;

procedure TRetrievePreparedClaim.Assign(Source: JS.TJSObject);
begin
  Exists := boolean(Source['Exists']);
  PrepareJobId := integer(Source['PrepareJobId']);
  ClaimId := integer(Source['ClaimId']);
  OldestDate := string(Source['OldestDate']);
  NewestDate := string(Source['NewestDate']);
  ImportId := string(Source['ImportId']);
  ClaimRef := string(Source['ClaimRef']);
  DonationCount := integer(Source['DonationCount']);
  Amount := currency(Source['Amount']);
  GiftAid := currency(Source['GiftAid']);
  GASDS := currency(Source['GASDS']);
  AggregatedDonations := currency(Source['AggregatedDonations']);
  OtherIncome := currency(Source['OtherIncome']);
  GASDSAdjustments := currency(Source['GASDSAdjustments']);
  Adjustments := currency(Source['Adjustments']);
  CommunityBuildings := currency(Source['CommunityBuildings']);
end;

{$ENDIF}


end.
